// navigation.js
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export const navigateTo = (path: any) => {
  if (!window.location.href.includes(path)) window.location.href = path;
};
